<template>
  <v-dialog
    v-model="_dialog"
    scrollable 
    eager
    max-width="100vw"
  >
    <v-card>
      <v-card-title primary-title class="headline">
        {{ item.nome }}
      </v-card-title>

      <v-card-text class="pt-2">
        <highcharts :options="chartOptions" />
      </v-card-text>

      <v-divider />

      <v-card-actions>
        <v-spacer />
        <v-btn text @click.stop="_dialog = false">
          Fechar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

export default {
  name: "DialogGraficoBoxplot",

  props: {
    dialogBoxplot: {
      type: Boolean,
      required: true,
    },
    item: {
      type: Object,
      required: true,
    },
  },

  computed: {
    _dialog: {
      get() {
        return this.dialogBoxplot;
      },
      set(newValue) {
        this.$emit("update:dialogBoxplot", newValue);
      }
    },
    chartOptions() {
      let options = JSON.parse(JSON.stringify(this.item.chartOptions));

      options.chart.height = undefined;
      options.chart.zoomType = 'y';
      options.xAxis.title.text = 'Cód. Material';

      return options;
    },
  },
}
</script>

<style>

</style>